/* APP */
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-pro/js/all';
import { Map } from './map';
/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/app-cms'; */

/* WADGALLERY
A décommenter si vous utilisez WadGallery */
import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery'; 
import Masonry from 'masonry-layout';
var imagesLoaded = require('imagesloaded');
import './wad-rgpd';
import "lightbox2";

$(document).ready(function(){
    // GOOGLE MAP
    let mapPlaceElement = document.getElementById('g-map'); 
    if (mapPlaceElement){
        Map.loadGoogleMapsApi().then(function(googleMaps) {
            let map = Map.createMap(googleMaps, mapPlaceElement);    
            let markerInfo = {
                latitude: 50.695041, 
                longitude: 5.250063,
                title: 'Le-Brummel',
                color: '#727582'
            };
            Map.addMarker(googleMaps, map, markerInfo);
        });
    }
    
    imagesLoaded( 'body', function() {
    	var msnry = new Masonry( '.grid', {
    		//columnWidth: 200,
    	    itemSelector: '.grid-item',
    	    gutter: 20,
    	    fitWidth: true
    	});
    	$('.grid').addClass('active');
    });
    
    $('.back-to-top').click(function(){
    	$('html, body').animate({ scrollTop: 0 }, 'slow');
    });
});
